import {autoProduct} from "../../basic/path"
import RequestModel from "../../basic/requestConfig";

export default {
  
    getProductLevel3List(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: autoProduct.productLevel3List,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    }
}
